<template>
    <div class="grid-bg">
      <div v-for="point in points" :key="point.id"
           class="grid-point" :style="pointStyle(point)"></div>
    </div>
  </template>

  <script>
  export default {
    data() {
      return {
        points: Array.from({ length: 40 }, (_, i) => ({
          id: i,
          x: Math.random() * 100,
          y: Math.random() * 100,
          size: Math.random() * 3 + 1,
          delay: Math.random() * 5
        }))
      }
    },
    methods: {
      pointStyle(point) {
        return {
          left: `${point.x}%`,
          top: `${point.y}%`,
          width: `${point.size}px`,
          height: `${point.size}px`,
          animationDelay: `${point.delay}s`,
          backgroundColor: `rgba(0, 180, 255, ${point.size / 5})`
        }
      }
    }
  }
  </script>

  <style scoped>
  .grid-bg {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .grid-point {
    position: absolute;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    animation: pulse 3s infinite ease;
  }

  @keyframes pulse {
    0%, 100% { opacity: 0.3; }
    50% { opacity: 0.8; transform: translate(-50%, -50%) scale(1.5); }
  }
  </style>